import React, { useEffect, useState } from 'react';
import { CARD_BORDER_RADIUS } from '../../Templates/ImpCard/ImpCard';
import styled from 'styled-components';
import { ImpDivider, ImpButton, ImpSpacer, ImpCard, ImpCardThumbnail, ImpContainer, ImpText, ImpFlex, colors, zIndex, } from '../..';
var CardDesignStatus;
(function (CardDesignStatus) {
    CardDesignStatus["SELECTABLE"] = "SELECTABLE";
    CardDesignStatus["NOT_SELECTABLE"] = "NOT_SELECTABLE";
})(CardDesignStatus || (CardDesignStatus = {}));
export default function ImpCardDesignSelection({ defaultSelection = 0, title, options, isLoading, isSubmitting, onSelect, primaryActionButtonInfo, outOfStockLabel, }) {
    const [selectedCardId, setSelectedCardId] = useState(null);
    useEffect(() => {
        if (options.length > 0 && defaultSelection < options.length) {
            const id = options[defaultSelection].id;
            handleSelect(id);
        }
    }, [options, defaultSelection]);
    const handleSelect = (id) => {
        if (!isSubmitting) {
            setSelectedCardId(id);
            onSelect(id);
        }
    };
    const selectedCard = options.find((option) => option.id === selectedCardId);
    if (isLoading || !selectedCard) {
        return (React.createElement(ImpContainer, { width: "min(370px, 100%)", textAlign: "center" },
            React.createElement(ImpFlex, { direction: "column", align: "center" },
                React.createElement(ImpText, { typography: "headline2" }, title),
                React.createElement(ImpSpacer, { height: "l" }),
                React.createElement(ImpContainer, { width: "258px", height: "162px", backgroundColor: colors.surface.surfaceHigh, borderRadius: `${CARD_BORDER_RADIUS}px` }),
                React.createElement(ImpSpacer, { height: "s" }),
                React.createElement(ImpContainer, { height: "24px", width: "160px", isLoading: true }),
                React.createElement(ImpSpacer, { height: "xs" }),
                React.createElement(ImpContainer, { height: "24px", width: "100px", isLoading: true }),
                React.createElement(ImpSpacer, { height: "l" }),
                React.createElement(ImpContainer, { width: "min(375px, 100%)" },
                    React.createElement(ImpButton, { state: "loading", size: "fill" })))));
    }
    const primaryActionButtonState = () => {
        if (isSubmitting)
            return 'submitting';
        if (!selectedCard || selectedCard.status == CardDesignStatus.NOT_SELECTABLE)
            return 'disabled';
        return 'enabled';
    };
    return (React.createElement(ImpContainer, { width: "min(370px, 100%)", textAlign: "center" },
        React.createElement(ImpFlex, { direction: "column", align: "center" },
            React.createElement(ImpText, { typography: "headline2" }, title),
            React.createElement(ImpSpacer, { height: "l" }),
            React.createElement(ImpContainer, { position: "relative" },
                React.createElement(ImpCard, { hoverable: (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.status) === CardDesignStatus.SELECTABLE, shimmer: true, src: selectedCard.src }),
                (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.status) === CardDesignStatus.NOT_SELECTABLE && (React.createElement(OutOfStockNote, { label: outOfStockLabel }))),
            React.createElement(ImpSpacer, { height: "s" }),
            React.createElement(ImpText, { color: colors.content.onBackground, typography: "label1" }, selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.title),
            React.createElement(ImpText, { typography: "body2", color: colors.content.onBackgroundVariant }, selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.fee),
            React.createElement(ImpSpacer, { height: "2xl" }),
            React.createElement(ImpDivider, { color: colors.border.borderVariant }),
            React.createElement(ImpSpacer, { height: "xl" }),
            React.createElement(ImpContainer, { width: "100%" },
                React.createElement(ImpFlex, { direction: "row", gap: "xs", flexWrap: true, justify: "center" }, options.map((option) => (React.createElement(ImpCardThumbnail, { key: option.id, src: option.src, isSelected: option.id === selectedCardId, onClick: () => handleSelect(option.id) }))))),
            React.createElement(ImpSpacer, { height: "xl" }),
            React.createElement(ImpContainer, { width: "min(375px, 100%)" },
                React.createElement(ImpButton, { onClick: primaryActionButtonInfo.onClick, state: primaryActionButtonState(), buttonStyle: "branded", size: "fill" }, primaryActionButtonInfo.text)))));
}
const OutOfStockOverlay = styled(ImpContainer) `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  background-color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
`;
const OutOfStockBadge = styled(ImpContainer) `
  box-shadow: 0px 16px 48px 0px #0000001f;
`;
function OutOfStockNote({ label }) {
    return (React.createElement(OutOfStockOverlay, { borderRadius: `${CARD_BORDER_RADIUS}px` },
        React.createElement(ImpFlex, { direction: "column", justify: "flex-end", align: "center", fluid: true },
            React.createElement(OutOfStockBadge, { width: "calc(100% - 16px)", height: "48px", backgroundColor: colors.surface.surfaceHigh, zIndex: zIndex.cardWrapper + 1, borderRadius: "8px" },
                React.createElement(ImpFlex, { fluid: true, justify: "center", align: "center" },
                    React.createElement(ImpText, { typography: "body3" }, label))),
            React.createElement(ImpSpacer, { height: "s" }))));
}
//# sourceMappingURL=ImpCardDesignSelection.js.map